import './staff/staff';
import './page-slider';
import './contacts/contacts';
import './news/news';
import './about/about';
import './project/project';